import React from 'react';

import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';
import { TLoopContainerBlock } from '../../../../../blocks/LoopContainer';
import { TBlock } from '../../../../../blocks/types';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style?: TBlock['style']): TLoopContainerBlock => ({
  id: generateRandomBlockId(),
  type: 'LoopContainer',
  style: {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 'normal',
    padding: '16px 24px 16px 24px',
    textAlign: 'left',
    ...style,
  },
  props: {
    loopTemplate: '"one two three" | split: " "',
    loopArgumentName: 'val',
    loopIndexName: 'index',
    blocks: [],
  },
  sectionProps: {},
});

export default defineBlockButton<TLoopContainerBlock>({
  label: 'Loop',
  icon: <BlockTypeIcon type="LoopContainer" />,
  defaultBlock: () => getDefaultProps(),
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
